export const STICKY_TH = {
    c1: "fieldset-th sla-compare-sticky sla-compare-sticky--1",
    c2: "fieldset-th sla-compare-sticky sla-compare-sticky--2",
    c3: "fieldset-th sla-compare-sticky sla-compare-sticky--3",
    c4: "fieldset-th sla-compare-sticky sla-compare-sticky--4",
    c2_3: "fieldset-th sla-compare-sticky sla-compare-sticky--2-3",
    c1_3: "fieldset-th sla-compare-sticky sla-compare-sticky--1-3",
};

export function stickyMeasureTh(colspanValue) {
    return colspanValue === 2 ? STICKY_TH.c2_3 : STICKY_TH.c2;
}
